// base64url (RFC 4648 §5, без «=»): строковый вид двоичных данных в записях модулей

export function bytesToBase64Url(bytes: Uint8Array): string {
  let binary = ''
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte)
  })

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

/** Строка не base64url — исключение (его даёт atob) */
export function base64UrlToBytes(text: string): Uint8Array {
  const binary = atob(text.replace(/-/g, '+').replace(/_/g, '/'))

  return Uint8Array.from(binary, (char) => char.charCodeAt(0))
}
